<template>
  <footer id="footer">
    <div class="content">

      <div class="col links">
        <div class="footerlogo"><router-link :to="{ name: 'landing', params: {} }">Pledge2019.eu</router-link></div>
        <p><router-link :to="{ name: 'privacy' }">{{ $t('pages.recurring-signup.privacy-policy') }}</router-link></p>
      </div>

      <div class="col about">
        <p>{{ $t('components.footer.responsible') }}<br>
          epicenter.works – Plattform Grundrechtspolitik<br>
          Widerhofergasse 8/2/4, 1090 Wien, {{ $t('components.footer.austria') }}<br>
          team &lt;AT&gt; epicenter.works
        </p>
        <p>{{ $t('components.footer.content') }} <a :href="`https://creativecommons.org/licenses/by/4.0/deed.${language}`" target="_blank">CC-BY 4.0</a></p>
        <p>All portraits of Member of the European Parliament as well as the voice recordings of their names:<br>
          © European Union – Source: European Parliament</p>
      </div>

      <div class="col contact-mep">
        <p>{{ $t('components.footer.you-are-a-mep') }}</p>
        <p>{{ $t('components.footer.contact-us') }} <a href="mailto:mep@pledge2019.eu">mep@pledge2019.eu</a></p>
      </div>

    </div>
  </footer>
</template>

<script>
export default {
  name: 'SectionFooter',
  computed: {
    language () {
      return this.$route.params.lang
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang=scss scoped>
@import '@/assets/styles/_variable.scss';

@media screen and (max-width: 768px) {
  .content {
    flex-wrap: wrap;

    .col {
      flex: 1 0 100% !important;
    }
  }
}

footer {
  background-color: #333;
  color: #ccc;
  padding: 1em;
  min-height: 0;

  a {
    color: #aaa;
    text-decoration: none;
    &:hover {
      color: #eee;
    }
  }

  .content {
    display: flex;
    justify-content: space-around;

    .col {
      flex: 1;
      margin: 0 1em;

      p {
        font-size: 0.8em;
        line-height: 1.2em;
      }

      &.links {
        margin: .6em 0;
        .footerlogo {
          font-weight: bold;
          font-size: 1.2em;
        }
      }
      &.contact-mep {
        flex: 1;
        background-color: $dark-text-color;
        color: $main-bg;
        padding: .5em 1em;
        align-self: center;
        a {
          font-weight: bold;
          color: inherit;
        }
      }
    }

  }
}
</style>
